import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const ImageBig = ({ image }) => {
  const base = 'relative w-full h-auto lg:h-full aspect-[3/4] lg:aspect-auto'
  return (
    <div className={base}>
      <Image
        src={urlForImage(image).url()}
        alt={image.alt}
        fill
        placeholder="blur"
        blurDataURL={image.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default ImageBig
